import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  FaCalendarCheck,
  FaFolder,
  FaPlus,
  FaSearch,
  FaUser,
  FaUserSecret,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Language, LanguageSharp } from "@mui/icons-material";
import { t } from "i18next";

const NavbarTwo = () => {
  
  const [active, setActive] = useState(false);
  const [searchShow, setSearchShow] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const menuActive = () => {
    setActive(!active);
  };
  const searchActive = () => {
    setSearchShow(!searchShow);
  };

  // Check if token exists in the cookie when the component is mounted
  useEffect(() => {
    const token = Cookies.get("access_token");

    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = () => {
    Cookies.remove("access_token"); // Remove token from cookie
    setIsLoggedIn(false); // Update state to reflect the user is logged out
    window.location.href = "/login"; // Redirect to login page after logout
  };

  // Control sidebar navigation
  let items = document.querySelectorAll(".menu-item-has-children > a");
  for (let i in items) {
    if (items.hasOwnProperty(i)) {
      items[i].onclick = function () {
        this.parentElement
          .querySelector(".sub-menu")
          .classList.toggle("active");
        this.classList.toggle("open");
      };
    }
  }

  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // Optional: Handle direction for Arabic
    if (lng === "ar") {
      document.dir = "rtl";
      document.body.style.fontFamily = "Tajawal, sans-serif"; // Optional: use Arabic font
    } else {
      document.dir = "ltr";
      document.body.style.fontFamily = ""; // Reset to default
    }
  };
  return (
    <>
      {/* search popup start*/}
      <div
        className={searchShow ? "td-search-popup active" : "td-search-popup "}
        id="td-search-popup"
      >
        <form action="/" className="search-form">
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search....."
            />
          </div>
          <button type="submit" className="submit-btn">
            <FaSearch />
          </button>
        </form>
      </div>

      {/* ==================== Navbar Two Start ====================*/}
      <nav className="navbar navbar-area navbar-area-2 navbar-expand-lg">
        <div className="container nav-container">
          <div className="responsive-mobile-menu">
            <button
              onClick={menuActive}
              className={
                active
                  ? "menu toggle-btn d-block d-lg-none open"
                  : "menu toggle-btn d-block d-lg-none"
              }
              data-target="#itech_main_menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-left" />
              <span className="icon-right" />
            </button>
          </div>
          <div className="logo">
            <Link to="/">
              <img
                src="/assets/img/hna-meak/Hna_m3ak_logo.png"
                style={{ width: "500px" }}
                alt="img"
              />
            </Link>
          </div>
          <div
            className={
              active
                ? "collapse navbar-collapse sopen"
                : "collapse navbar-collapse"
            }
            id="itech_main_menu"
          >
            <ul className="navbar-nav menu-open text-lg-end">
              <li>
                <Link to="/">{t('navbar.home')} </Link>
              </li>
              <li className="menu-item-has-children">
                <a href="#">{t('navbar.service.title')}</a>
                <ul className="sub-menu">
                  <li>
                    <Link to="/service">{t('navbar.service.service')}</Link>
                  </li>
                  <li>
                    <Link to="/service-details">{t('navbar.service.serviceSingle')}</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <a href="#">{t('navbar.pages.title')}</a>
                <ul className="sub-menu">
                  <li>
                    <Link to="/about">{t('navbar.pages.about')}</Link>
                  </li>
                  <li>
                    <Link to="/team">{t('navbar.pages.team')}</Link>
                  </li>
                  <li>
                    <Link to="/team-details">{t('navbar.pages.teamDetails')}</Link>
                  </li>
                  <li>
                    <Link to="/case-study-details">{t('navbar.pages.caseStudy')}</Link>
                  </li>
                </ul>
              </li>
              {/* <li className='menu-item-has-children'>
                <a href='#'>Blog</a>
                <ul className='sub-menu'>
                  <li>
                    <Link to='/blog'>Blog</Link>
                  </li>
                  <li>
                    <Link to='/blog-details'>Blog Details</Link>
                  </li>
                </ul>
              </li> */}
              <li>
                <Link to="/contact">{t('navbar.contact')}</Link>
              </li>
              {isLoggedIn && (
                <li className="menu-item-has-children">
                  <a href="#">{t('navbar.monEspace.title')}</a>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/mon-espace">{t('navbar.monEspace.profile')}</Link>
                    </li>

                    <li>
                      <Link onClick={handleLogout}>{t('navbar.monEspace.logout')} </Link>
                    </li>
                  </ul>
                </li>
              )}

              {!isLoggedIn && (
                <li className="menu-item-has-children">
                  <a href="#">{t('navbar.connexion.title')}</a>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/login">{t('navbar.connexion.login')}</Link>
                    </li>
                    <li>
                      <Link to="/register">{t('navbar.connexion.register')}</Link>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </div>
          <div className="nav-right-part nav-right-part-desktop align-self-center">
            <Link to="/members/inscription" className="btn btn-border-base">
               {t('navbar.becomeMember')} <FaPlus />
            </Link>
          </div>

          <div className="language-switcher ms-auto">
            <Link onClick={() => changeLanguage("fr")} className=" me-4 ms-4">
              Français
            </Link>
            <Link onClick={() => changeLanguage("ar")} className="">
              العربية
            </Link>
          </div>
        </div>
      </nav>
      {/* ==================== Navbar Two end ====================*/}
    </>
  );
};

export default NavbarTwo;
